import ServiceDetail from '@/components/feature/ServiceDetail';

export default function SocialAnalyticsPage() {
  return <ServiceDetail slug="social-analytics" />;
}